export default __webpack_public_path__ + "static/media/3.610becf0.png";